import utils from '../../utils'
export default {

  created() {
    this.score = this.$s.getScore()
  },

  mounted() {
    let path = this.$route.path
    let page;
    if(path.includes('score')) {
      page = 'score'
    } else if (path.includes('reason')) {
      if(this.score >= 0 && this.score <= 8) {
        page = 'unsatisfied_reason'
      } else {
        page = 'satisfied_reason'
      }
    } else if (path.includes('advice')) {
      page = 'otherwise_contact'
    }
    //页面访问上报
    utils.native.reportEvent({
      event_id: "advance_element_action",
      element_id: "nps_pages_action",
      page: page,
      action: "show",
      amount: 1
    })
  },

  methods: {
    routerReplace(name) {
      this.$router.replace({
        name
      })
    },

    routerPush(name) {
      this.$router.push({
        name
      })
    },

    //检查分数，如果不正常则返回打分页面
    checkScore() {
      if(!this.score || this.score < 0) {
        this.routerReplace('Score')
      }
    },

    //禁用back键
    disableBack() {
      if (window.history && window.history.pushState) {
        // 往历史记录里面添加一条新的当前页面的url
        history.pushState(null, null, document.URL);
        // 给 popstate 绑定一个方法 监听页面刷新
        window.addEventListener('popstate', this._goBack, false);//false阻止默认事件
      }
    },

    _goBack() {
      history.pushState(null, null, document.URL);
    }
  }
};
